<template>
  <div :style="{width:width?width:'28px'}" class="voice-img" @click="clickVoice">
    <slot></slot>
    <img v-if="!isRecording" src="../../assets/images/voice/voice.png" alt="">
    <img v-else src="../../assets/images/voice/voice.gif" alt="">
      <!-- <button @click="translationStart">开始</button>
      <button @click="translationEnd">停止</button> -->
  </div>
</template>
<script>
import IatRecorder from './js/IatRecorder';
const iatRecorder = new IatRecorder('en_us','mandarin','9abbbfb0')//小语种-中文方言-appId
export default {
  name:"xmlVoiceRecognition",
  props:{
    width:{
      type:String,
      default:''
    }
  },
  data() {
    return {
      isRecording: false,
      timeout: null,
    };
  },
  methods: {
    clickVoice(){
      if(this.isRecording){
        this.translationEnd()
      }else{
        this.translationStart()
      }
    },
    translationStart() {
      this.isRecording=true;
      iatRecorder.start();
      iatRecorder.onTextChange = (text) => {
        let inputText = text;
        this.searchData = inputText.substring(0, inputText.length - 1); //文字处理，因为不知道为什么识别输出的后面都带‘。’，这个方法是去除字符串最后一位
        this.$emit('getVoiceData', this.searchData);
        console.log(this.searchData);
        
      };
      
      iatRecorder.onEnd = (e) => {
        this.translationEnd();
      };
      
      // this.timeout=setTimeout(() => {
      //   this.translationEnd();
      // }, 1000*30);
    },
    translationEnd() {
      this.isRecording=false;
      clearTimeout(this.timeout);
        this.timeout=null;
      
      iatRecorder.stop();
    },
    }
};
</script>

<style scoped lang="scss">
.voice-img{
  width: 28px;
  cursor: pointer;
  img{
    width: 100%;
  }
}
</style>